<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Description" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.description ? activePayment.description : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Amount" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.amount ? (Math.round(activePayment.amount * 100) / 100).toFixed(2) + "€" : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Reference number" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.reference_no ? activePayment.reference_no : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Payer IBAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.payer_iban ? activePayment.payer_iban : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Payer name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.payer_name ? activePayment.payer_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Payment key" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.payment_key ? activePayment.payment_key : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activePayment.payment_type
                        ? activePayment.payment_type.charAt(0).toUpperCase() + activePayment.payment_type.slice(1)
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-row v-if="activePayment && activePayment.deadline">
            <v-col class="col-item row-title" cols="3">{{ "Deadline" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.deadline ? activePayment.deadline : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activePayment && activePayment.postback_sent_at">
            <v-col class="col-item row-title" cols="3">{{ "Postback sent at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.postback_sent_at ? tz(activePayment.postback_sent_at) : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"/>
        <div v-if="activePayment.payment_type === 'periodic'">
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Frequency" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ activePayment.frequency ? activePayment.frequency : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Start date" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ activePayment.start_date ? activePayment.start_date : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "End date" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ activePayment.end_date ? activePayment.end_date : "-" }}
                </v-col>
            </v-row>
            <v-divider class="mt-3 mb-3"/>
        </div>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Partner payment reference" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.partner_payment_reference ? activePayment.partner_payment_reference : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.status ? activePayment.status : "-" }}
                <span
                    v-if="activePayment.status"
                    :style="{ 'background-color': getStatusColor(activePayment.status) }"
                    class="dot"
                ></span>
            </v-col>
        </v-row>
        <v-row v-if="activeBankName">
            <v-col class="col-item row-title" cols="3">{{ "Bank name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBankName ? activeBankName : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activePayment.swift">
            <v-col class="col-item row-title" cols="3">{{ "Swift" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.swift ? activePayment.swift : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activePayment && activePayment.platform">
            <v-col class="col-item row-title" cols="3">{{ "Platform" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activePayment.platform
                        ? activePayment.platform.charAt(0).toUpperCase() + activePayment.platform.slice(1)
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"/>
        <v-row v-if="user.role === 'admin'">
            <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.company_name ? activePayment.company_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Recipient IBAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.recipient_iban ? activePayment.recipient_iban : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Recipient name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.recipient_name ? activePayment.recipient_name : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"/>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Created at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.created_at ? tz(activePayment.created_at) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Last updated" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.updated_at ? tz(activePayment.updated_at) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Ext status checked at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.ext_status_checked_at ? tz(activePayment.ext_status_checked_at) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Ext status recieved at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activePayment.ext_status_rcvd_at ? tz(activePayment.ext_status_rcvd_at) : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {paymentColorMixin} from "@/mixins/payment-color-mixin";

export default {
    name: "payment-info-tab",
    mixins: [paymentColorMixin],
    computed: {
        ...mapState(["user", "bank_names"]),
        ...mapState("paymentHistory", ["activePayment"])
    },
    data() {
        return {
            activeBankName: null
        };
    },
    async beforeUpdate() {
        this.activeBankName = null;
        if (this.activePayment) {
            for (let i = 0; i < this.bank_names.length; i++) {
                if (this.activePayment.swift === Object.values(this.bank_names)[i].swift) {
                    this.activeBankName = Object.values(this.bank_names)[i].name;
                    break;
                }
            }
        }
    },
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.dot {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    display: inline-block;
}
</style>
